/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: common/media.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
export namespace common.v1 {
    export class Media extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            url?: string;
            type?: string;
            order?: number;
            description?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("url" in data && data.url != undefined) {
                    this.url = data.url;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("order" in data && data.order != undefined) {
                    this.order = data.order;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
            }
        }
        get url() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set url(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get order() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set order(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            url?: string;
            type?: string;
            order?: number;
            description?: string;
        }): Media {
            const message = new Media({});
            if (data.url != null) {
                message.url = data.url;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            if (data.order != null) {
                message.order = data.order;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            return message;
        }
        toObject() {
            const data: {
                url?: string;
                type?: string;
                order?: number;
                description?: string;
            } = {};
            if (this.url != null) {
                data.url = this.url;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.order != null) {
                data.order = this.order;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.url.length)
                writer.writeString(1, this.url);
            if (this.type.length)
                writer.writeString(2, this.type);
            if (this.order != 0)
                writer.writeInt32(3, this.order);
            if (this.description.length)
                writer.writeString(4, this.description);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Media {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Media();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.url = reader.readString();
                        break;
                    case 2:
                        message.type = reader.readString();
                        break;
                    case 3:
                        message.order = reader.readInt32();
                        break;
                    case 4:
                        message.description = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Media {
            return Media.deserialize(bytes);
        }
    }
}
